import React from "react";
import { ReactComponent as IconTipoAtencion } from "../../../assets/img/icon/dashboard/tipo_atencion.svg";
import { KPIDoughnutSummary } from "./KPIDoughnutSummary";
import { queryChartType } from "../schemas/kpi-props.schema";
import { CubeBasicFilters } from "../schemas/kpi.types";

export const KPICarouselDoughnut: React.FC<{
    cubeFilters: CubeBasicFilters;
}> = ({ cubeFilters }) => {
    return (
        <div className="siniestralidad-container">
            <div className="header-section">
                <div className="icon-wrapper">
                    <IconTipoAtencion />
                </div>
                <h2 className="title-label">Por tipo de atención</h2>
            </div>
            <div className={"row"}>
                <div className={"col mb-3 mb-lg-0"}>
                    <KPIDoughnutSummary
                        cubeFilters={cubeFilters}
                        typeInquiry={queryChartType.OUTPATIENT_VS_INPATIENT}
                        titleChart={"Ambulatorio vs. Hospitalario"}
                        titleFlag={true}
                    />
                </div>
                <div className={"col mb-2 mb-lg-0"}>
                    <KPIDoughnutSummary
                        cubeFilters={cubeFilters}
                        typeInquiry={queryChartType.INPATIENT_BY_RELATIONSHIP}
                        titleChart={"Hospitalario por parentesco"}
                        titleFlag={true}
                    />
                </div>
                <div className={"col mb-2 mb-lg-0"}>
                    <KPIDoughnutSummary
                        cubeFilters={cubeFilters}
                        typeInquiry={queryChartType.OUTPATIENT_BY_RELATIONSHIP}
                        titleChart={"Ambulatorio por parentesco"}
                        titleFlag={true}
                    />
                </div>
            </div>
        </div>
    );
};
